module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "ruleForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.ruleForm,
      "status-icon": "",
      "rules": _vm.rules,
      "label-width": "120px"
    }
  }, [_c('div', {
    staticClass: "bottom",
    staticStyle: {
      "height": "50px",
      "line-height": "50px",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('span', {
    staticStyle: {
      "display": "line-block",
      "margin-left": "30px"
    }
  }, [_vm._v(_vm._s(_vm.modifyType == 1 ? '修改密码' : '修改手机'))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "display": "block",
      "width": "70px",
      "height": "2px",
      "background": "#F56C6C",
      "margin-left": "22px"
    }
  })]), _vm._v(" "), (_vm.modifyType == 1) ? _c('div', [_c('el-form-item', {
    staticStyle: {
      "margin-top": "30px"
    },
    attrs: {
      "label": "手机号",
      "prop": "pass"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "420px"
    },
    attrs: {
      "disabled": true,
      "autocomplete": "off"
    },
    model: {
      value: (_vm.ruleForm.pass),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "pass", $$v)
      },
      expression: "ruleForm.pass"
    }
  }), _vm._v(" "), _c('span', {
    ref: "oldCode",
    staticClass: "classCode",
    on: {
      "click": function($event) {
        return _vm.xgmmCode()
      }
    }
  }, [_vm._v("获取验证码")])], 1), _vm._v(" "), _c('div', {
    staticClass: "error"
  }, [_c('el-form-item', {
    attrs: {
      "label": "验证码",
      "prop": "oldCode"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "420px"
    },
    attrs: {
      "placeholder": "请输入验证码",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.ruleForm.oldCode),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "oldCode", $$v)
      },
      expression: "ruleForm.oldCode"
    }
  }), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "position": "fixed",
      "bottom": "-9999px"
    },
    attrs: {
      "autocomplete": "off"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "原密码",
      "prop": "Original"
    }
  }, [_c('el-input', {
    staticStyle: {
      "position": "fixed",
      "bottom": "-9999px"
    },
    attrs: {
      "type": "password",
      "autocomplete": "off"
    }
  }), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "420px"
    },
    attrs: {
      "type": "password",
      "placeholder": "请输入原密码",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.ruleForm.Original),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "Original", $$v)
      },
      expression: "ruleForm.Original "
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "新密码",
      "prop": "newNum"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "420px"
    },
    attrs: {
      "type": "password",
      "placeholder": "请输入新密码",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.ruleForm.newNum),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "newNum", $$v)
      },
      expression: "ruleForm.newNum"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "确认新密码",
      "prop": "makesure"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "420px"
    },
    attrs: {
      "type": "password",
      "placeholder": "请确认新密码"
    },
    model: {
      value: (_vm.ruleForm.makesure),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "makesure", _vm._n($$v))
      },
      expression: "ruleForm.makesure"
    }
  })], 1)], 1)], 1) : _c('div', [_c('el-form-item', {
    staticStyle: {
      "margin-top": "30px"
    },
    attrs: {
      "label": "原手机号码",
      "prop": "pass"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "420px"
    },
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.ruleForm.originalPhone),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "originalPhone", $$v)
      },
      expression: "ruleForm.originalPhone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "登录密码",
      "prop": "loginPassword"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "420px"
    },
    attrs: {
      "placeholder": "请输入登录密码"
    },
    model: {
      value: (_vm.ruleForm.loginPassword),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "loginPassword", $$v)
      },
      expression: "ruleForm.loginPassword"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-top": "30px"
    },
    attrs: {
      "label": "新手机号",
      "prop": "newPhone"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "420px"
    },
    attrs: {
      "placeholder": "请输入新手机号"
    },
    model: {
      value: (_vm.ruleForm.newPhone),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "newPhone", $$v)
      },
      expression: "ruleForm.newPhone"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "codenumber",
    class: {
      'active': _vm.countdownActive
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.xgphoneCode()
      }
    }
  }, [_vm._v("\r\n        " + _vm._s(_vm.countdownActive ? (_vm.countdown + " 秒") : '获取验证码') + "\r\n      ")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "验证码",
      "prop": "newCode"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "420px"
    },
    attrs: {
      "placeholder": "请输入验证码",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.ruleForm.newCode),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "newCode", $$v)
      },
      expression: "ruleForm.newCode"
    }
  }), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "position": "fixed",
      "bottom": "-9999px"
    },
    attrs: {
      "autocomplete": "off"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "padding": "20px 0 50px 0"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.submitForm(_vm.modifyType)
      }
    }
  }, [_vm._v("提交")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.resetForm('ruleForm')
      }
    }
  }, [_vm._v("重置")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-92eb8b12!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/system/modify.vue
// module id = 1726
// module chunks = 3